import { db, firebase } from "firebase";
import { Observable } from "rxjs";
import { Account } from "types";

export interface MRRResponse {
  totalMrrCents: number; // e.g., 1234567 = $12,345.67
}

const fetchJson = async <T>(url: string): Promise<T> => {
  const currentUser = firebase.auth().currentUser;
  const token = await currentUser?.getIdToken(true);

  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) throw new Error(response.statusText);
  return response.json() as Promise<T>;
};

export const getTodayMRR = async (): Promise<MRRResponse> => {
  return fetchJson<MRRResponse>("cs/mrr");
};

export const getPaidSubscribers = async (): Promise<Account[]> => {
  const accounts = await db
    .collection("accounts")
    .where("plan", "in", ["premium", "pro", "enterprise"])
    .where("status", "==", "active")
    .get();
  return accounts.docs.map((doc) => {
    return {
      id: doc.id,
      ...doc.data(),
    };
  }) as Account[];
};

export const getActiveTrials = async (): Promise<Account[]> => {
  const accounts = await db
    .collection("accounts")
    .where("plan", "in", ["premium", "pro", "enterprise"])
    .where("status", "==", "trialing")
    .get();
  return accounts.docs.map((doc) => {
    return {
      id: doc.id,
      ...doc.data(),
    };
  }) as Account[];
};

export const getDashboardRealtimeStats = () => {
  return new Observable((subscriber) => {
    db.collection("aggregates").onSnapshot((result) => {
      subscriber.next(result.docs);
    });
  });
};
